export default __webpack_public_path__ + "static/media/logo-pintou-parceria.10ab42dc.png";